var $9c47fa309a7d4d43$exports = {};
$9c47fa309a7d4d43$exports = {
  "backButton": args => "\u0627\u0644\u0631\u062C\u0648\u0639 \u0625\u0644\u0649 ".concat(args.prevMenuButton),
  "moreActions": "\u0627\u0644\u0645\u0632\u064A\u062F \u0645\u0646 \u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A",
  "unavailable": "\u063A\u064A\u0631 \u0645\u064F\u062A\u0648\u0641\u0631\u060C \u0642\u064F\u0645 \u0628\u0627\u0644\u062A\u0648\u0633\u064A\u0639 \u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644"
};
export { $9c47fa309a7d4d43$exports as default };